import script from "./FeedbackUpdate.vue?vue&type=script&lang=ts&setup=true"
export * from "./FeedbackUpdate.vue?vue&type=script&lang=ts&setup=true"

import "./FeedbackUpdate.vue?vue&type=style&index=0&id=f6875b5c&lang=scss"

const __exports__ = script;

export default __exports__